// extracted by mini-css-extract-plugin
export default {"table":"AssociatedWireless_table__4qZjS","defaultMethod":"AssociatedWireless_defaultMethod__zzAo5"};